import React from 'react';
import { ConfigHelper } from '../../config/ConfigHelper';
import configJson from './site-search-config.json';
import { stringOrDefault } from '../../utils';
import { useMediaQuery } from 'react-responsive';
import ResultView, {
  title,
  titleContents,
  wrapperLink,
  wrapper,
  thumbnail,
  defaultThumbnail,
  attribute,
  attributeLabel,
  attributeValue,
  featuredLabel,
} from '../../components/ResultView';
import { useLayoutMode } from '../../components/Layout';
import HeBrandmarkIcon from './../../icons/HeBrandmark';
import { css } from '@linaria/core';
import { trackSearchResultClick } from '../../utils/dataLayer';
import { withSearch } from '@elastic/react-search-ui';

const configHelper = new ConfigHelper(configJson);

export const summary = css`
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 10px;

  [data-layout-mode='grid'] & {
    padding: 0 20px;
  }

  em {
    background-color: #b5e9f8;
    font-style: normal;
  }
`;

function SiteSearchResultView({
  current,
  onClickLink,
  result,
  resultsPerPage,
  searchTerm,
}) {
  const isTabletUp = useMediaQuery({ query: '(min-width: 800px)' });
  const { layoutMode } = useLayoutMode();

  if (result.path === undefined) {
    return null;
  }

  const attributes = [
    {
      label: 'Category',
      value: stringOrDefault(result.category, undefined),
    },
  ];

  const filteredAttributes = attributes.filter(attr => {
    if (layoutMode === 'grid') {
      return attr.label === 'Category';
    }
    return true;
  });

  const content = (
    <>
      <div className={wrapper}>
        {stringOrDefault(result['imageUrl'], undefined)
          ? layoutMode === 'grid' && (
              <img
                alt={stringOrDefault(result['imageAlt'], '')}
                className={thumbnail}
                src={`${configHelper.getBaseURLField()}${result['imageUrl']}?autorotate=true&width=${isTabletUp ? 550 : 500}&height=${isTabletUp ? 392 : 400}&mode=crop&quality=90&upscale=true`}
              />
            )
          : layoutMode === 'grid' && (
              <div className={defaultThumbnail}>
                <HeBrandmarkIcon />
              </div>
            )}
        {result.featured === true && (
          <div className={featuredLabel}>Featured result</div>
        )}
        <h2
          className={title}
          data-featured-result={result.featured === true ? '' : undefined}
        >
          <span className={titleContents}>
            {layoutMode === 'grid' ? (
              <span dangerouslySetInnerHTML={{ __html: result.name }} />
            ) : (
              <a
                dangerouslySetInnerHTML={{ __html: result.name }}
                href={configHelper.getBaseURLField() + result.path}
                onClick={() => {
                  trackSearchResultClick(
                    result._meta.id,
                    result._meta.resultNumber,
                    result.name,
                    result.path,
                    current,
                    resultsPerPage,
                    searchTerm,
                  );
                  onClickLink();
                }}
              />
            )}
          </span>
        </h2>

        {stringOrDefault(result['imageUrl'], undefined) &&
          !isTabletUp &&
          layoutMode === 'list' && (
            <img
              alt={stringOrDefault(result['imageAlt'], '')}
              className={thumbnail}
              src={`${configHelper.getBaseURLField()}${result['imageUrl']}?autorotate=true&width=760&height=452&mode=crop&quality=90&upscale=false`}
            />
          )}

        {stringOrDefault(result.summary, undefined) && (
          <div
            className={summary}
            dangerouslySetInnerHTML={{
              __html: stringOrDefault(result.summary, undefined),
            }}
          />
        )}

        {filteredAttributes
          .filter(item => item.value !== undefined)
          .map((item, index) => (
            <div className={attribute} key={index}>
              <div className={attributeLabel}>{item.label}:</div>
              <div
                className={attributeValue}
                dangerouslySetInnerHTML={{ __html: item.value }}
              />
            </div>
          ))}
      </div>

      {stringOrDefault(result['imageUrl'], undefined) &&
        isTabletUp &&
        layoutMode === 'list' && (
          <img
            alt={stringOrDefault(result['imageAlt'], '')}
            className={thumbnail}
            src={`${configHelper.getBaseURLField()}${result['imageUrl']}?autorotate=true&width=400&height=400&mode=crop&quality=90&upscale=false`}
          />
        )}
    </>
  );

  if (layoutMode === 'grid') {
    return (
      <ResultView>
        <a
          className={wrapperLink}
          href={configHelper.getBaseURLField() + result.path}
          onClick={() => {
            trackSearchResultClick(
              result._meta.id,
              result._meta.resultNumber,
              result.name,
              result.path,
              current,
              resultsPerPage,
              searchTerm,
            );
            onClickLink();
          }}
        >
          {content}
        </a>
      </ResultView>
    );
  }

  return <ResultView>{content}</ResultView>;
}

export default withSearch(({ current, resultsPerPage, searchTerm }) => ({
  current,
  resultsPerPage,
  searchTerm,
}))(SiteSearchResultView);
